import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="repitleCompanySearch";
export function queryByText(queryText) {
  return axios({
    url: `/ws/${moduleName}/queryByText/${queryText}`,
    method: 'get',
  })
}
export default {
  queryByText
}